module.exports = __webpack_public_path__ + "img/birthplace-cb-lockup.8a7c2f54.png";